// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CredentialLoginHealthStatusSchema = z.enum(['HEALTHY','NEEDS_ATTENTION','CONTRADICTED','SHARED_ACCOUNT_SUSPECTED'] as const);

export type CredentialLoginHealthStatusType = `${z.infer<typeof CredentialLoginHealthStatusSchema>}`

export default CredentialLoginHealthStatusSchema;
